import { AiOutlineFileDone, AiOutlineContacts } from "react-icons/ai";
import { VscTasklist } from "react-icons/vsc";
import { FaStackOverflow } from "react-icons/fa";

export const barChartListPageOne = [
  {
    name: "OHSE Reviews Completed - Regional Offices",
    yAxisName: "",
    xAxisName: "",
    value: "meetingCountTopAtFiveROs",
    type: "stack",
    isMines: true,
    isHo: true,
    // isRO: false,
  },
  {
    name: "OHSE Reviews Completed - Mines",
    yAxisName: "Count",
    xAxisName: "",
    value: "meetingCountTopAtFiveMines",
    type: "stack",
    isMines: true,
    isHo: false,
  },
  {
    name: "Task Status - Regional Offices",
    yAxisName: "Count",
    xAxisName: "",
    value: "outstandingTaskAtTopFiveROs",
    type: "stack",
    isMines: true,
    isHo: true,
  },

  // {
  //   name: "Overdue Tasks - Top 5 ROs",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "overDueTaskAtTopFiveROs",
  //   type: "bar",
  // },

  {
    name: "Task Status - Mines",
    yAxisName: "Count",
    xAxisName: "",
    value: "outstandingTaskAtTopFiveMines",
    type: "stack",
    isMines: true,
    isHo: false,
  },
  // {
  //   name: "Overdue Tasks - Top 5 Mines",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "overDueTaskAtTopFiveMines",
  //   type: "bar",
  // },
  // {
  //   name: "Meetings Completed - Mine Wise",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "meetingCompletedMineWise",
  //   type: "bar",
  // },
  // {
  //   name: "Meetings Completed - RO Wise",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "meetingCompletedROWise",
  //   type: "bar",
  // },
  // {
  //   name: "Overdue Meeting Tasks - Mine Wise",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "taskOverDueMineWise",
  //   type: "bar",
  // },
  // {
  //   name: "Overdue Meeting Tasks - RO Wise",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "taskOverDueROWise",
  //   type: "bar",
  // },
];

export const barPieChartListPageTwo = [
  {
    title: "OHSE Review - By Types",
    value: "numberOfMeetings",
  },
  {
    title: "Tasks Status",
    value: "meetingTask",
  },
  {
    title: "OHSE Review - By Status",
    value: "meetingStatus",
  },
  // {
  //   title: "Status of Meetings (After approved by Approver)",
  //   value: "statusOfMeetingPieChart",
  // },
  {
    title: "OHSE Review Distribution",
    value: "meetingDistribution",
  },
  {
    name: "OHSE Reviews Completed - Last 12 months",
    yAxisName: "Count",
    xAxisName: "",
    value: "monthsWiseMeetings",
    type: "barWithLabelMonth",
    isMines: true,
  },
  // {
  //   title: "No of meeting site wise",
  //   value: "numberOfMeetingsSiteWise",
  // },
  // {
  //   title: "no Of Task (Assigned , Completed , OverDue)",
  //   value: "noOfTaskAssignedCompletedOverDue",
  // },
];
export const OHSCWWigetListOne = [
  // {
  //   name: "Meetings Completed - HO",
  //   key: 'meetingCompletedHO',
  //   value: '',
  // },
  // {
  //   name: "Tasks Overdue - HO",
  //   key: 'taskOverDueHO',
  //   value: '',
  // },
  // {
  //   name: "Average Task Completion Period",
  //   key: 'averageTaskCompletionPeriod',
  //   value: '',
  // },
];
export const OHSCWWigetListTwo = [
  {
    name: "OHSE Reviews Completed",
    key: "meetingCompleted",
    value: "",
    icon: AiOutlineFileDone,
  },
  {
    name: "Tasks Assigned",
    key: "taskAssigned",
    value: "",
    icon: AiOutlineContacts,
  },
  {
    name: "Tasks Completed",
    key: "taskCompleted",
    value: "",
    icon: VscTasklist,
  },
  {
    name: "Tasks Overdue",
    key: "taskOverDue",
    value: "",
    icon: FaStackOverflow,
  },
];
